import { FIRE_DEPARTMENT_IDS, LEPC_IDS } from "../../../constants";
import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Caroline County LEPC Portal": {
    parameters: {
      linkUrls: ["https://gwrclepc.tieriiportal.aristatek.com/"],
      staffInputs: {
        fees: false,
        documentTypes: {
          submission: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.VA.CAROLINE_COUNTY,
          name: "Caroline County LEPC",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "VA",
    dependsOn: ["Tier2SubmitValidation"],
  },
  "Fredericksburg LEPC Portal": {
    parameters: {
      linkUrls: ["https://gwrclepc.tieriiportal.aristatek.com/"],
      staffInputs: {
        fees: false,
        documentTypes: {
          submission: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.VA.FREDERICKSBURG,
          name: "City of Fredericksburg LEPC",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "VA",
    dependsOn: ["Tier2SubmitValidation"],
  },
  "Richmond City Portal": {
    parameters: {
      linkUrls: ["https://tier2.erplan.net/onlinefiling/filingLogin.htm"],
      staffInputs: {
        fees: true,
        documentTypes: {
          invoice: true,
          receipt: true,
          report: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.VA.RICHMOND,
          name: "City of Richmond LEPC",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "VA",
    dependsOn: ["Tier2SubmitValidation"],
  },
  "Fairfax County Portal": {
    parameters: {
      linkUrls: ["https://fairfaxva.hazconnect.com/Account/Login.aspx"],
      staffInputs: {
        fees: false,
        documentTypes: {
          report: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.VA.FAIRFAX_COUNTY,
          name: "Fairfax Joint LEPC",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "VA",
  },
  "Henrico County Portal": {
    parameters: {
      linkUrls: ["https://hazmatreporting.henrico.us/Account/Login.aspx"],
      staffInputs: {
        documentTypes: {
          report: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.VA.HENRICO_COUNTY,
          name: "Henrico County LEPC",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "VA",
  },
  "King George County LEPC Portal": {
    parameters: {
      linkUrls: ["https://gwrclepc.tieriiportal.aristatek.com/"],
      staffInputs: {
        fees: false,
        documentTypes: {
          submission: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.VA.KING_GEORGE_COUNTY,
          name: "King George County LEPC",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "VA",
    dependsOn: ["Tier2SubmitValidation"],
  },
  "Roanoke Valley Joint LEPC Portal": {
    parameters: {
      linkUrls: ["https://roanoke.tieriiportal.aristatek.com/"],
      staffInputs: {
        fees: false,
        documentTypes: {
          submission: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.VA.ROANOKE_VALLEY_JOINT,
          name: "Roanoke Valley Joint LEPC",
        },
        {
          id: LEPC_IDS.VA.BOTETOURT_COUNTY,
          name: "Botetourt County LEPC",
        },
        {
          id: LEPC_IDS.VA.CRAIG_COUNTY,
          name: "Craig County LEPC",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "VA",
    dependsOn: ["Tier2SubmitValidation"],
  },
  "Spotsylvania County LEPC Portal": {
    parameters: {
      linkUrls: ["https://gwrclepc.tieriiportal.aristatek.com/"],
      staffInputs: {
        fees: false,
        documentTypes: {
          submission: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.VA.SPOTSYLVANIA_COUNTY,
          name: "Spotsylvania County LEPC",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "VA",
    dependsOn: ["Tier2SubmitValidation"],
  },
  "Stafford County LEPC Portal": {
    parameters: {
      linkUrls: ["https://gwrclepc.tieriiportal.aristatek.com/"],
      staffInputs: {
        fees: false,
        documentTypes: {
          submission: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.VA.STAFFORD_COUNTY,
          name: "Stafford County LEPC",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "VA",
    dependsOn: ["Tier2SubmitValidation"],
  },
  "Virginia Certification Letter": {
    parameters: {
      staffInputs: {
        documentTypes: {
          certification: true,
        },
      },
    },
    jurisdictionType: "State",
    state: "VA",
  },
  "City of Lynchburg Portal": {
    parameters: {
      linkUrls: ["https://lynchburg.tieriiportal.aristatek.com/"],
      staffInputs: {
        fees: false,
        documentTypes: {
          submission: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.VA.LYNCHBURG,
          name: "City of Lynchburg LEPC",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "VA",
    dependsOn: ["Tier2SubmitValidation"],
  },
  "Mecklenburg County LEPC Portal": {
    parameters: {
      linkUrls: ["https://mecklenburg.tieriiportal.aristatek.com/"],
      staffInputs: {
        fees: false,
        documentTypes: {
          receipt: false,
          submission: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.VA.MECKLENBURG_COUNTY,
          name: "Mecklenburg County LEPC",
        },
      ],
    },

    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "VA",
    dependsOn: ["Tier2SubmitValidation"],
  },
  "Newport News Fire Department Portal": {
    parameters: {
      linkUrls: ["https://newportnews.tieriiportal.aristatek.com/"],
      staffInputs: {
        fees: false,
        documentTypes: {
          submission: true,
        },
      },
      includeFireDistricts: [
        {
          id: FIRE_DEPARTMENT_IDS.VA.NEWPORT_NEWS_FIRE_DEPARTMENT,
          name: "Newport News Fire Dept",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "VA",
    dependsOn: ["Tier2SubmitValidation"],
  },
  "Prince William County Portal": {
    parameters: {
      linkUrls: [
        "https://www.notion.so/encamp/7140712780864ff2b37facb42458b148?v=9f6157b1b53d44dfb6248c55f26b2aaa",
      ],
      staffInputs: {
        fees: false,
        documentTypes: {
          report: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.VA.PRINCE_WILLIAM_COUNTY,
          name: "Prince William County",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "VA",
  },
  "Peninsula Joint LEPC (Newport News)": {
    parameters: {
      linkUrls: [
        "https://www.notion.so/encamp/7140712780864ff2b37facb42458b148?v=9f6157b1b53d44dfb6248c55f26b2aaa",
      ],
      staffInputs: {
        fees: false,
        documentTypes: {
          submission: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.VA.PENINSULA_JOINT_LEPC,
          name: "Peninsula Joint LEPC (Newport News)",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "VA",
    dependsOn: ["Tier2SubmitValidation"],
  },
};
